/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S1_BodyInputs */

const en_landing_guide_s1_body = /** @type {(inputs: Landing_Guide_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 is a text-to-image and image-editing model from Ideogram, released on September 30, 2026 in Ideogram's own app, its API and through launch partners. Earlier models treated every edit as a fresh render, so colours shifted, textures softened and small details moved a little on each pass. The new model focuses on multi-turn editing: you change one part of a picture, then another, and the parts you did not ask about stay where they were. It still generates from text at native 2K and keeps the lettering Ideogram is known for.`)
};

const zh_landing_guide_s1_body = /** @type {(inputs: Landing_Guide_S1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 是 Ideogram 推出的文生图与图像编辑模型，于 2026 年 9 月 30 日在 Ideogram 应用、API 及合作平台同步上线。过去的模型把每次编辑都当作一次重新渲染，于是每改一次，颜色就偏一点、纹理就糊一点、细节就挪一点。Ideogram AI 4.5 专注多轮编辑：你改一处，再改一处，没让它动的地方始终保持原样。它依然支持原生 2K 文生图，并保留 Ideogram 闻名的文字排版能力。`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 is a text-to-image and image-editing model from Ideogram, released on September 30, 2026 in Ideogram's own app, its API and through launch partn..." |
*
* @param {Landing_Guide_S1_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s1_body = /** @type {((inputs?: Landing_Guide_S1_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S1_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s1_body(inputs)
	return zh_landing_guide_s1_body(inputs)
});
export { landing_guide_s1_body as "landing.guide.s1_body" }